<template>
    <div>
        <textarea ref="tinymceRef" />
    </div>
</template>

<script>
//引入编辑器配置
import defaultToolbarConfig from './config/defaultToolbarConfig';
import simpleToolbarConfig from './config/simpleToolbarConfig';
export default {
    props: {
        //内容
        value: {
            type: String
        },
        // 1是默认类型 2是简易理性
        type: {
            type: [Number, String],
            default: 1
        },
        height: {
            type: [Number, String],
            default: 0
        },
        //是否禁用
        disabled: {
            type: Boolean,
            default: false
        },
        // 语言设置
        language: {
            type: String,
            default: 'zh_CN'
        }
    },
    data() {
        return {
            isValueChange: true,
            init: {
                ...(this.type == 1 ? defaultToolbarConfig : simpleToolbarConfig),
                height: this.height || (this.type == 1 ? defaultToolbarConfig : simpleToolbarConfig).height,
                //汉化,路径是自定义的
                language_url: `/tinymce/langs/${this.$route.params.lang == 'cn' ? 'zh_CN' : 'en'}.js`,
                language: this.$route.params.lang == 'cn' ? 'zh_CN' : 'en',
                content_style: '.tox .tox-promotion{display:none;}',
                setup: ed => {
                    ed.on('init', () => {
                        this.editor = ed;
                        this.value && ed.setContent(this.value);
                        setTimeout(() => {
                            this.$emit('ready');
                            this.$watch(
                                'disabled',
                                newVal => {
                                    this.setEditorStyle(newVal);
                                },
                                { immediate: true }
                            );
                        }, 400); // 加个异步，防止ready事件在mounted之前触发
                    });
                    ed.on('change', e => {
                        this.isValueChange = false; // 值发生改变，重新标记
                        this.$emit('change', ed.getContent());
                    });
                }
            }
        };
    },
    watch: {
        value: {
            handler(newVal) {
                // 避免重复设置编辑器内容 如果编辑器内容为空时则去设置内容，否则不设置（重复设置后光标会一直在首行）
                if (this.isValueChange) {
                    newVal ? this.editor?.setContent(newVal) : this.editor?.setContent('');
                    this.isValueChange = true;
                } else {
                    this.isValueChange = true;
                }
            },
            immediate: true
        }
    },
    methods: {
        editInit() {
            tinymce.init({
                target: this.$refs.tinymceRef,
                promotion: false, // 去除升级按钮
                ...this.init
            });
        },
        // 在光标位置插入文本
        insertContent(html) {
            this.editor.insertContent(html);
        },
        // 获取编辑器内容
        handleGetContent() {
            let dom = this.editor.getContent();
            return dom;
            // this.$emit('save',dom)
        },
        // 设置编辑器内容
        setContent(html) {
            this.editor?.setContent(html);
        },
        // 设置编辑器是否可编辑的样式
        setEditorStyle(disabled) {
            let iframe = document.querySelector('.tox-edit-area__iframe');
            let iframeHtml = document.querySelector('.tox-edit-area__iframe')?.contentWindow.document.querySelector('html');
            if (disabled) {
                iframe && iframeHtml && ((iframe.style.background = '#F2F2F2'), (iframeHtml.style.cursor = 'not-allowed'));
            } else {
                iframe && iframeHtml && ((iframe.style.background = '#fff'), (iframeHtml.style.cursor = 'auto'));
            }
        }
    },
    mounted() {
        this.editInit();
    }
};
</script>

<style scoped lang="less">
.tox-notifications-container {
    display: none;
}

.tox-mbtn--select {
    min-width: 45px;
}
/*在页面正常使用时不用加这个样式，在弹窗使用时，要加这个样式，因为使用弹窗，z-index层数比较低，工具栏的一些工具不能使用，要将z-index层数提高。*/
.tox.tox-silver-sink.tox-tinymce-aux {
    z-index: 2100 !important;
}
.tox-tinymce .tox-tbtn {
    max-width: 85px !important;
}
/deep/ .tox-statusbar__branding {
    display: none;
}
</style>
